import React from 'react'
import HeaderLink from '../HeaderLink'


const DropDownBtn = (({ id, link , children,isActive,onClick})=>(
	<div onClick={onClick} className={isActive === true ? 'dropbtn js-active' : 'dropbtn'} data-id={id}>
		<HeaderLink text={link.caption} isActive={link.isActive}/>
	</div>
))

export default DropDownBtn 


// WEBPACK FOOTER //
// ./src/Components/DropDownBtn/index.js